if (!customElements.get('vb2-popup-trigger')) {
  let openedFromQuery = false;

  class VB2PopupTrigger extends HTMLElement {
    connectedCallback() {
      if (this.eventController) return;
      this.eventController = new AbortController();
      this.statusNode = this.querySelector('[data-vb2-popup-status]');
      this.pending = false;
      this.formOpen = false;
      const options = { signal: this.eventController.signal };

      document.addEventListener('click', event => {
        const trigger = event.target instanceof Element ? event.target.closest('a[href="#vb2-early-access"]') : null;
        if (!trigger || event.button !== 0) return;
        if (this.dataset.stage !== 'teaser') return;
        event.preventDefault();
        this.requestOpen(trigger);
      }, options);

      window.addEventListener('klaviyoForms', event => {
        if (String(event.detail?.formId) !== this.dataset.formId) return;
        if (event.detail.type === 'open') {
          this.clearPending();
          this.formOpen = true;
          this.announce('');
        } else if (event.detail.type === 'close') {
          this.clearPending();
          this.formOpen = false;
          this.announce('');
          const focusTarget = this.returnFocus;
          this.returnFocus = null;
          requestAnimationFrame(() => {
            if (!focusTarget?.isConnected) return;
            if (focusTarget.tabIndex < 0 && !focusTarget.hasAttribute('tabindex')) {
              focusTarget.setAttribute('tabindex', '-1');
              focusTarget.addEventListener('blur', () => focusTarget.removeAttribute('tabindex'), { once: true });
            }
            focusTarget.focus({ preventScroll: true });
          });
        }
      }, options);

      const fromQuery = () => {
        if (!this.isConnected || openedFromQuery || !['index', 'collection'].includes(this.dataset.pageType)) return;
        if (new URLSearchParams(window.location.search).get('vb2_early_access') !== '1') return;
        if (this.dataset.stage !== 'teaser') return;
        openedFromQuery = true;
        this.requestOpen(document.querySelector('#MainContent'));
      };

      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fromQuery, { ...options, once: true });
      else fromQuery();
    }

    disconnectedCallback() {
      this.clearPending();
      this.eventController?.abort();
      this.eventController = null;
    }

    isActive() {
      return this.dataset.enabled === 'true' && this.dataset.stage === 'teaser';
    }

    announce(message) {
      if (!this.statusNode) return;
      this.statusNode.hidden = !message;
      this.statusNode.textContent = message;
    }

    clearPending() {
      window.clearTimeout(this.waitTimer);
      this.waitTimer = null;
      this.pending = false;
      this.returnFocus?.removeAttribute('aria-busy');
    }

    fail() {
      this.clearPending();
      this.announce(this.dataset.failureCopy);
    }

    requestOpen(trigger) {
      if (this.dataset.stage !== 'teaser') return;
      if (!this.isActive()) {
        this.announce(this.dataset.inactiveCopy);
        return;
      }
      if (this.pending || this.formOpen) return;
      if (!/^[A-Za-z0-9]{6}$/.test(this.dataset.formId || '')) {
        this.fail();
        return;
      }
      this.returnFocus = trigger instanceof HTMLElement ? trigger : document.activeElement;
      this.returnFocus?.setAttribute('aria-busy', 'true');
      this.pending = true;
      this.announce(this.dataset.loadingCopy);
      try {
        window._klOnsite = window._klOnsite || [];
        this.waitTimer = window.setTimeout(() => {
          if (!this.isConnected || !this.isActive()) {
            this.clearPending();
            this.announce('');
            return;
          }
          this.fail();
        }, 10000);
        window._klOnsite.push(['openForm', this.dataset.formId]);
      } catch {
        this.fail();
      }
    }
  }

  customElements.define('vb2-popup-trigger', VB2PopupTrigger);
}
